import React from 'react';

export function Anaegjuvogin() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="92"
      height="139"
      viewBox="0 0 92 139"
    >
      <g
        id="Ársskýrsla/icon/Ánægjuvogin"
        fill="#163E63"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <path
          id="Fill-1"
          d="M3.52 129.285h2.046l-1.003-6.343h-.04l-1.003 6.343zm1.268-10.067H3.09l1.616-2.946h2.762l-2.68 2.946zm-2.087 15.55H.246l2.72-14.772h3.152l2.721 14.772H6.384l-.45-3.273H3.151l-.45 3.273z"
        ></path>
        <path
          id="Fill-3"
          d="M9.08524468 134.768387L9.08524468 119.995796 11.4383559 119.995796 14.5279507 128.445835 14.5684856 128.445835 14.5684856 119.995796 16.8604964 119.995796 16.8604964 134.768387 14.6507476 134.768387 11.4177904 125.540436 11.3766594 125.540436 11.3766594 134.768387z"
        ></path>
        <path
          id="Fill-5"
          d="M23.099 129.08h-1.655l1.655-5.423v5.423zm5.98-6.874v-2.21h-7.205l-4.767 14.772h2.578l1.063-3.478h2.35v3.478h5.97v-2.21h-3.646v-4.337h2.377v-2.21h-2.377v-3.805h3.658z"
        ></path>
        <path
          id="Fill-7"
          d="M33.31 127.28h4.153v7.559h-1.228l-.47-1.175c-.758.9-1.371 1.309-2.558 1.309-2.005 0-3.396-1.432-3.396-3.785v-7.612c0-2.087 1.227-3.785 3.723-3.785 2.538 0 3.806 1.841 3.806 4.051v.941h-2.414c0-2.21-.45-2.782-1.453-2.782-.614 0-1.125.368-1.125 1.616v7.591c0 .941.307 1.555 1.186 1.555 1.023 0 1.392-.572 1.392-2.046v-1.432h-1.617v-2.005z"
        ></path>
        <path
          id="Fill-9"
          d="M37.946 132.763h.532c.982 0 1.33-.409 1.33-1.227v-11.54h2.537v11.826c0 1.882-.757 3.03-3.56 3.03h-.84v-2.089z"
        ></path>
        <path
          id="Fill-11"
          d="M43.871 119.996h2.537v11.15c0 1.085.43 1.617 1.35 1.617.922 0 1.351-.532 1.351-1.616v-11.151h2.537v11.048c0 2.538-1.473 3.929-3.887 3.929-2.415 0-3.888-1.391-3.888-3.929v-11.048z"
        ></path>
        <path
          id="Fill-13"
          d="M63.27 131.126c0 1.105.326 1.637 1.35 1.637 1.022 0 1.35-.532 1.35-1.637v-7.488c0-1.105-.328-1.637-1.35-1.637-1.024 0-1.35.532-1.35 1.637v7.488zm-2.538-7.55c0-2.087 1.227-3.785 3.887-3.785s3.888 1.698 3.888 3.785v7.612c0 2.087-1.228 3.785-3.888 3.785s-3.887-1.698-3.887-3.785v-7.612z"
        ></path>
        <path
          id="Fill-15"
          d="M73.234 127.28h4.154v7.488H76.16l-.47-1.104c-.758.9-1.372 1.309-2.559 1.309-2.005 0-3.396-1.432-3.396-3.785v-7.612c0-2.087 1.228-3.785 3.724-3.785 2.537 0 3.806 1.841 3.806 4.051v.941H74.85c0-2.21-.45-2.782-1.452-2.782-.614 0-1.126.368-1.126 1.616v7.591c0 .941.307 1.555 1.187 1.555 1.023 0 1.391-.572 1.391-2.046v-1.432h-1.616v-2.005z"
        ></path>
        <path
          id="Fill-17"
          d="M79.0865927 134.768178L81.6238993 134.768178 81.6238993 119.995588 79.0865927 119.995588z"
        ></path>
        <path
          id="Fill-19"
          d="M83.1994853 134.768387L83.1994853 119.995796 85.5525966 119.995796 88.6421913 128.445835 88.6827263 128.445835 88.6827263 119.995796 90.9747371 119.995796 90.9747371 134.768387 88.7649883 134.768387 85.532031 125.540436 85.4909 125.540436 85.4909 134.768387z"
        ></path>
        <path
          id="Fill-21"
          d="M16.16 113.787h2.537V99.014H16.16v14.773zm1.514-15.55h-1.699l1.617-2.947h2.762l-2.68 2.946z"
        ></path>
        <path
          id="Fill-23"
          d="M24.897 102.656c-.102-1.268-.778-1.637-1.35-1.637-.82 0-1.27.532-1.27 1.453 0 2.517 5.157 3.724 5.157 7.734 0 2.435-1.637 3.786-4.01 3.786-2.353 0-3.704-1.883-3.806-4.092l2.414-.348c.102 1.493.696 2.23 1.514 2.23.88 0 1.474-.47 1.474-1.35 0-2.926-5.157-3.704-5.157-7.94 0-2.352 1.432-3.682 3.929-3.682 2.067 0 3.294 1.493 3.52 3.58l-2.415.266z"
        ></path>
        <path
          id="Fill-25"
          d="M28.8254485 113.786951L28.8254485 99.0143599 31.3627551 99.0143599 31.3627551 111.577202 35.3524634 111.577202 35.3524634 113.786951z"
        ></path>
        <path
          id="Fill-27"
          d="M36.0895729 113.786951L36.0895729 99.0143599 42.8827471 99.0143599 42.8827471 101.224109 38.6265814 101.224109 38.6265814 105.029621 41.9003716 105.029621 41.9003716 107.23937 38.6265814 107.23937 38.6265814 111.577202 43.1688759 111.577202 43.1688759 113.786951z"
        ></path>
        <path
          id="Fill-29"
          d="M43.5376244 113.786951L43.5376244 99.0143599 45.8907356 99.0143599 48.9803304 107.464399 49.0211634 107.464399 49.0211634 99.0143599 51.3125781 99.0143599 51.3125781 113.786951 49.1028293 113.786951 45.8701701 104.558999 45.8290391 104.558999 45.8290391 113.786951z"
        ></path>
        <path
          id="Fill-31"
          d="M57.574 102.656c-.102-1.268-.777-1.637-1.35-1.637-.819 0-1.269.532-1.269 1.453 0 2.517 5.156 3.724 5.156 7.734 0 2.435-1.636 3.786-4.01 3.786-2.353 0-3.703-1.883-3.805-4.092l2.414-.348c.102 1.493.695 2.23 1.514 2.23.88 0 1.473-.47 1.473-1.35 0-2.926-5.156-3.704-5.156-7.94 0-2.352 1.432-3.682 3.929-3.682 2.066 0 3.294 1.493 3.519 3.58l-2.415.266z"
        ></path>
        <path
          id="Fill-33"
          d="M61.0939502 113.786951L61.0939502 99.0143599 63.6312569 99.0143599 63.6312569 104.477333 63.6720898 104.477333 66.3318953 99.0143599 68.8692019 99.0143599 66.1274325 104.518166 69.2170273 113.786951 66.6388877 113.786951 64.5722033 106.91211 64.5313703 106.91211 63.6312569 108.549006 63.6312569 113.786951z"
        ></path>
        <path
          id="Fill-35"
          d="M72.184 108.303h2.046l-1.002-6.343h-.041l-1.003 6.343zm-.818 5.484H68.91l2.722-14.773h3.15l2.722 14.773h-2.455l-.45-3.274h-2.783l-.45 3.274z"
        ></path>
        <path
          id="Fill-38"
          d="M0 138.78799L54.5805563 138.78799 54.5805563 137.595787 0 137.595787z"
        ></path>
        <path
          id="Fill-39"
          d="M57.9157449 138.78799L91.2974367 138.78799 91.2974367 137.595787 57.9157449 137.595787z"
        ></path>
        <path
          id="Fill-40"
          d="M60.2120179 120.010192L56.2410868 138.191888 52.2704538 120.010192z"
        ></path>
        <path
          id="Fill-41"
          d="M68.8241367 4.97379915e-14L45.3562113 88.9926097 21.8885839 4.97379915e-14z"
        ></path>
      </g>
    </svg>
  );
}
